import React, { useEffect, useState } from 'react'
import images from 'assets/images/Guidelines_page-0001.jpg'
import { Outlet, useNavigate } from 'react-router-dom'
import Api from 'utils/api'
import sideimg from '../../../assets/images/Abstract Creative Idea Brain Bulb Logo (1).png'
import PngFiles from 'assets/images/pngfiles'
import Languages from 'components/languages/languages'

function Useronboard() {
  const pathname = window.location.pathname.split('/')
  const navigate = useNavigate()
  const [pass, setPass] = useState()

  const getUser = async () => {
    const { response } = await Api('/pass', 'get')
    if (response) setPass(response.data)
  }

  const onLoad = () => {
    getUser()
  }

  useEffect(onLoad, [])

  return (
    <div className='tw-grid md:tw-h-screen tw-items-stretch md:tw-grid-cols-2 md:tw-p-0 tw-p-5'>
      <div className='md:tw-flex tw-items-center tw-justify-center d:tw-h-screen tw-hidden  tw-bg-linen'>
        <div className='tw-block  tw-w-96'>
          <img src={PngFiles.LogoEA} alt='' />
        </div>
      </div>

      <div className='tw-flex tw-flex-col md:tw-px-4 tw-py-8'>
        <div className='tw-flex tw-justify-end tw-h-[5%] sm:tw-w-[384px] tw-w-[90%] tw-mx-auto'><Languages /></div>
        <div className='tw-w-full h-full tw-h-[95%] tw-flex  tw-items-center tw-justify-center'>
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default Useronboard
